import styled from '@emotion/styled';
import MonthGridComp from '../MonthGrid';
import { useCallback, useContext, useEffect, useState } from 'react';
import { CalendarContext, setCurrentPage } from '../reducer/CalendarContext';
import {
  APPEND_PAGES_COUNT,
  MergeableEventListItem,
  Schedule,
} from '../reducer';
import { useThrottle } from '../hooks/useThrottle';
import { getCurrentScrollTop } from '../reducer/useCalendarProvider';
import { DateTime } from 'infras/datetime';

interface Props {
  onClickEvent?: (event: MergeableEventListItem, el: HTMLElement) => void;
  onClickMoreEvent?: (date: DateTime, el: HTMLElement) => void;
  onClickDay?: (date: DateTime, el: HTMLElement) => void;
  onUpdateSchedule?: (schedule: Schedule) => void;
  selectedEventId?: string;
}

const Component = (props: Props) => {
  const { state, dispatch } = useContext(CalendarContext);
  const [scrollTop, setScrollTop] = useState<number | null>(null);

  const onScrollMonthGrid = useCallback(
    useThrottle((e: any) => {
      setScrollTop(window.scrollY);
    }, 500),
    [],
  );

  useEffect(() => {
    if (!state.isReady) return;
    const top = getCurrentScrollTop(state.currentPage);
    setScrollTop(top);
    window.scrollTo(0, top);
    window.onscroll = onScrollMonthGrid;
  }, [state.isReady]);

  // スクロール
  useEffect(() => {
    if (scrollTop === null) {
      return;
    }
    const els = document.getElementsByClassName('js-vertical-scroll-item');
    let height = 0;
    let centerLine = 0;
    for (let page = 0; page <= els.length; page++) {
      // HeaderとFooter分のバッファを設けて次のページの先読みに不具合が起きないようにしている
      // 値は要調整
      if (height > scrollTop + 200) {
        const newPage = page - 1;
        dispatch(setCurrentPage(newPage));
        break;
      }
      height += els[page].clientHeight;
      centerLine = Math.ceil(els[page].clientHeight);
    }
  }, [scrollTop]);

  // ページ移動時
  useEffect(() => {
    if (!state.isReady) return;
    // SET_CURRENT_PAGEで一番最初にいったら元の日時のでページまで戻す
    if (state.currentPage === 0) {
      window.scrollTo(
        0,
        window.scrollY + getCurrentScrollTop(APPEND_PAGES_COUNT),
      );
      dispatch(setCurrentPage(APPEND_PAGES_COUNT));
    }
  }, [state.isReady, state.currentPage]);

  if (!state.isInit || !state.showRange.month) return null;

  return (
    <VerticalParentScroller>
      {state.pages.map((startedAt, page) => (
        <VerticalParentScrollerItem
          key={page}
          data-page={page}
          className={'js-vertical-scroll-item'}
        >
          <MonthGridComp
            page={page}
            startedAt={startedAt}
            onClickEvent={props.onClickEvent}
            onClickMoreEvent={props.onClickMoreEvent}
            onClickDay={props.onClickDay}
            selectedEventId={props.selectedEventId}
            onUpdateSchedule={props.onUpdateSchedule}
          />
        </VerticalParentScrollerItem>
      ))}
    </VerticalParentScroller>
  );
};

const VerticalScroller = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: inherit;
`;
const VerticalScrollerItem = styled.div`
  display: flex;
  width: inherit;
`;

const VerticalParentScroller = styled(VerticalScroller)`
  overflow-y: auto;
`;
const VerticalParentScrollerItem = styled(VerticalScrollerItem)``;

export default Component;
